// extracted by mini-css-extract-plugin
export default {"Panel":"MetricCounter_Panel__VosCD","ValueContainer":"MetricCounter_ValueContainer__unsYZ","NoData":"MetricCounter_NoData__7OkLn"};